import { render, staticRenderFns } from "./BaseStarRating.vue?vue&type=template&id=d1f5ae60&"
import script from "./BaseStarRating.vue?vue&type=script&lang=js&"
export * from "./BaseStarRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports